module.exports = __webpack_public_path__ + "img/cluster_nutrition_100px_bluebox.69cb7c54.png";